var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-type-heading"},[_c('OrdersCount',{attrs:{"variant":"bullet","color":_vm.getStautsColor()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }